import Radio from './component';

export default Radio;
